import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { DataUtils } from "../../common/views/DataUtils";
import { RouteUtils } from "../../common/views/RouteUtils";
import { AccountConfirmModel, AuthTokensInfo, ResetPasswordModel } from "../models/AccountTypes";
import { AccountService } from "../services/AccountService";

export function useResetPasswordVM(info: AccountConfirmModel) {
    const service = new AccountService();

    const [loading, setLoading] = useState(false);

    const { form, setField, resetForm, errorMessages,
        summaryText, summaryType } = useForm<ResetPasswordModel>({
            code: info.code,
            userId: info.userId,
            password: ""
        });

    const reset = () => {
        setLoading(true);

        const request = service.resetPassword(form);

        DataUtils.onRequest(request, onResult);
    }

    const onResult = (result: IDataResult) => {
        const account = result.data as AuthTokensInfo;

        if (result.status === ResponseStatus.success && account != null) {
            onSuccess(account);
        } else {
            onFail();
        }

        setLoading(false);
    }

    const onSuccess = (account: AuthTokensInfo) => {
        RouteUtils.onLoggedIn(account);
        resetForm();
    }

    const onFail = () => {
        RouteUtils.onLoggedOut()
    }

    return {
        errorMessages,
        summaryText,
        summaryType,
        form,
        setField,

        loading,
        setLoading,

        reset
    }
}